import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  const currentYear = 2026;

  const mainLinks = [
    { id: 'footer_home', label: 'Home', href: '/homepage' },
    { id: 'footer_gallery', label: 'Gallery', href: '/gallery' },
    { id: 'footer_about', label: 'About', href: '/about' },
    { id: 'footer_client', label: 'Client Access', href: '/client-access' },
  ];

  const legalLinks = [
    { id: 'legal_privacy', label: 'Privacy', href: '#' },
    { id: 'legal_terms', label: 'Terms', href: '#' },
  ];

  return (
    <footer className="border-t border-border py-12 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Single Row Layout */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-500 rounded-lg flex items-center justify-center">
              <Image
                src="/logo-nobg.png"
                alt="SukeMedia Logo"
                width={35}
                height={35}
                style={{ maxWidth: 'none' }}
                className="object-contain"
              />
              {/* <Icon name="CameraIcon" size={20} className="text-background" /> */}
            </div>
            <span className="text-sm font-medium text-muted-foreground">
              © {currentYear} SukeMedia
            </span>
          </div>

          {/* Main Links */}
          <nav className="flex items-center gap-8">
            {mainLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className="text-sm font-medium text-muted-foreground hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Social & Legal */}
          <div className="flex items-center gap-6">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/sukemedia"
              target="_blank"
              rel="noopener noreferrer"
              className="h-8 flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-white transition-colors"
              aria-label="Instagram @sukemedia"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
                aria-hidden="true"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.805.249 2.227.413.56.218.96.478 1.38.898.42.42.68.82.898 1.38.164.422.36 1.057.413 2.227.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.249 1.805-.413 2.227-.218.56-.478.96-.898 1.38-.42.42-.82.68-1.38.898-.422.164-1.057.36-2.227.413-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.249-2.227-.413a3.71 3.71 0 0 1-1.38-.898 3.71 3.71 0 0 1-.898-1.38c-.164-.422-.36-1.057-.413-2.227-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.054-1.17.249-1.805.413-2.227.218-.56.478-.96.898-1.38.42-.42.82-.68 1.38-.898.422-.164 1.057-.36 2.227-.413 1.266-.058 1.646-.07 4.85-.07M12 0C8.741 0 8.333.014 7.053.072 5.775.13 4.903.333 4.14.63a5.88 5.88 0 0 0-2.126 1.384A5.88 5.88 0 0 0 .63 4.14C.333 4.903.13 5.775.072 7.053.014 8.333 0 8.741 0 12s.014 3.667.072 4.947c.058 1.278.261 2.15.558 2.913a5.88 5.88 0 0 0 1.384 2.126A5.88 5.88 0 0 0 4.14 23.37c.763.297 1.635.5 2.913.558C8.333 23.986 8.741 24 12 24s3.667-.014 4.947-.072c1.278-.058 2.15-.261 2.913-.558a5.88 5.88 0 0 0 2.126-1.384 5.88 5.88 0 0 0 1.384-2.126c.297-.763.5-1.635.558-2.913.058-1.28.072-1.688.072-4.947s-.014-3.667-.072-4.947c-.058-1.278-.261-2.15-.558-2.913a5.88 5.88 0 0 0-1.384-2.126A5.88 5.88 0 0 0 19.86.63C19.097.333 18.225.13 16.947.072 15.667.014 15.259 0 12 0m0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m6.406-11.845a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88" />
              </svg>
              <span>@sukemedia</span>
            </a>

            {/* Legal Links */}
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              {legalLinks.map((link, index) => (
                <span key={link.id} className="flex items-center gap-4">
                  <Link href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </Link>
                  {index < legalLinks.length - 1 && <span className="text-muted">·</span>}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
